<template>
  <base-modal :show="show"
              @close="close"
              size="small">
    <div slot="header">
      {{ $t("screentimeManagement.playPauseWouldNotWork") }}
    </div>

    <div>
      {{ $t("screentimeManagement.userExceededScreentime", { name }) }}

      <div class="btn-group">
        <base-button color="primary"
                     :rounded="false"
                     @click="editScreentime">
          {{ $t("adjustScreenTime") }}
        </base-button>

        <base-button color="secondary"
                     :rounded="false"
                     @click="close">
           {{ $t("cancel") }}
        </base-button>
      </div>
    </div>
  </base-modal>
</template>

<script>
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    data() {
      return {
        fromBus: {
          childId: ''
        }
      }
    },

    computed: {
      name() {
        return this.fromBus.name
      }
    },

    methods: {
      editScreentime() {
        this.showModal('screentime', {
          child: this.fromBus.child
        })

        this.close()
      }
    },

    beforeMount() {
      this.setOpenListener('exhaustedAlert')
    }
  }
</script>

<style lang="scss" scoped>
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-around;

    margin-top: 24px;
  }
</style>

